const url = {
  validate (value) {
    return (
      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[^\s]*)?$/.test(value)
    )
  },
}

export { url }
